<template>
  <div style="min-height: 100vh;">
    <div v-if="!showWhitePage" style="min-height: 100vh">
      <passInfo
        v-if="wechatEve"
        :history-detail="historyDetail"
        :qr-code="qrCodeImgUrl"
        @changeQrCode="refreshQrCode"
        @refreshInfo="() => getInfo(true)"
      />
      <div v-else class="checkPage">
        <div class="head">
          请输入手机号验证身份
        </div>
        <div class="phone">
          <input v-model.trim="phone" type="text" placeholder="点击这里，录入手机号">
        </div>
        <div class="btn">
          <van-button type="primary" @click="onMatch">匹配</van-button>
        </div>
      </div>
    </div>
    <div v-else class="whitePage">
      <div v-if="notFound">
        <div class="svgArea">
          <svg-icon icon-class="locked" class="none" />
        </div>
        <div class="back">
          <span @click="goBack">
            根据手机号未匹配到您的邀约记录
            <br>
            返回首页
          </span>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { inviteInfo } from '@/api/home';
import config from '@/common/config';
import passInfo from './passCodeInfo';
export default {
  name: 'QrCode',
  components: {
    passInfo
  },
  data() {
    return {
      code: null, // code 为true显示二维码，false为邀请码
      baseURL: process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro,
      codeMsg: '',
      expiredStatus: ['FINISH', 'UNVISIT', 'OUTTIME_VISIT', 'OUTTIME_AUDIT', 'CANCEL', 'INVALID'], // 显示访问已失效的状态
      timestamp: (new Date()).getTime(),
      phone: '',
      id: this.$route.query.id || '',
      showWhitePage: true,
      notFound: false,
      wechatEve: true,
      historyDetail: {},
      qrCodeImgUrl: '',
      inviteInfos: {
        beVisitStaffName: '',
        visitDate: '',
        beVisitEdificeName: '',
        beVisitFloorName: '',
        qrCode: '',
        askCode: '',
        visitorStatus: ''
      },
      statusMap: {
        FACE: '人脸识别',
        IC: ' IC卡',
        QR: '二维码',
        '': '无'
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === 'staffMeetingHistoryDetail/:id/:activeName') {
        vm.getInfo(true);
      }
    });
  },
  watch: {
    $route(to, from) {
      if (from.name === 'bindByPhone' || from.name === 'bind') {
        location.reload();
      }
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo(refresh) {
      const data = {
        id: this.id
      };
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') { // 在微信下对比下手号码是不是正确的
        const personalInfo = localStorage.getItem('personalInfo');
        if (personalInfo) {
          const info = JSON.parse(personalInfo);
          data.phone = info.phone;
          inviteInfo(data).then(res => {
            if (ua.match(/MicroMessenger/i) == 'micromessenger') { // 在微信下对比下手号码是不是正确的
              if (res.code === 200) {
                this.historyDetail = res.data;
                this.historyDetail.visitDate = this.historyDetail.visitDate.slice(0, -3);
                this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(res.data.qrCode)}&timestamp=${new Date().getTime()}`;
                let auth = '';
                res.data.authTypes && res.data.authTypes.forEach((item, index) => {
                  if (index === res.data.authTypes.length - 1) {
                    auth += this.statusMap[item];
                  } else {
                    auth += `${this.statusMap[item]}、`;
                  }
                });
                this.historyDetail.authTypes = auth;
                this.showWhitePage = false;
              }
            }
          }).catch(_ => {
            this.notFound = true;
          });
        } else {
          // 回滚回去 注释
          this.$router.push({ name: 'bindByPhone', query: { inviteId: this.id }});
          // sessionStorage.setItem('enterUrl', window.location.href);
          // this.$router.push({ name: 'bind' });
        }
      } else { // 普通浏览器打开
        if (refresh) {
          this.onMatch();
        } else {
          this.wechatEve = false;
          this.showWhitePage = false;
        }
      }
    },
    onMatch() {
      const data = {
        id: this.id,
        phone: this.phone
      };
      inviteInfo(data).then(res => {
        if (res.code === 200) {
          this.historyDetail = res.data;
          this.historyDetail.visitDate = this.historyDetail.visitDate.slice(0, -3);
          this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(res.data.qrCode)}&timestamp=${new Date().getTime()}`;
          let auth = '';
          res.data.authTypes && res.data.authTypes.forEach((item, index) => {
            if (index === res.data.authTypes.length - 1) {
              auth += this.statusMap[item];
            } else {
              auth += `${this.statusMap[item]}、`;
            }
          });
          this.historyDetail.authTypes = auth;
          this.showWhitePage = false;
          this.wechatEve = true;
        }
      });
    },
    refreshQrCode() {
      this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(this.historyDetail.qrCode)}&timestamp=${new Date().getTime()}`;
    },
    goBack() {
      this.$router.push({ name: 'user' });
    }
  }
};
</script>

<style lang="less">
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}
.checkPage {
  background-color: #FFFFFF;
  min-height: 100vh;

  .head {
    display: flex;
    justify-content: center;
    //padding: 1;
    .change_val(font-size, 42);
    .change_val(padding, 42);
  }
  .phone {
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: center;
    .change_val(margin, 20);

    input{
      width: 80%;
      text-align: center;
      background:none;
      outline:none;
      border:none;
      .change_val(font-size, 48);
      .change_val(padding, 2);
    }
  }

  .btn {
    display: flex;
    justify-content: center;
  }

}
.whitePage {
  background-color: #FFFFFF;
  min-height: 100vh;
  .svgArea {
    display: flex;
    justify-content: center;
    .none {
      .change_val(width, 350);
      .change_val(height, 350);
      .change_val(margin-top, 150);
    }
  }
  .back {
    display: flex;
    justify-content: center;
    .change_val(margin-top, 25);
    color: #3B86FF;
    .change_val(font-size, 28);

    span {
      text-align: center;
    }
  }

}
</style>
